/**
 * Date helpers that use local time (no UTC shift).
 * Use for calendar cells and any YYYY-MM-DD comparison so 1.5.2026 stays 1.5.2026.
 */

export function toLocalDateString(date: Date): string {
	const y = date.getFullYear();
	const m = String(date.getMonth() + 1).padStart(2, '0');
	const d = String(date.getDate()).padStart(2, '0');
	return `${y}-${m}-${d}`;
}

/** Store timeline dates at local noon so Gantt columns match the intended calendar day. */
export function toTimelineDateIso(date: Date): string {
	return `${toLocalDateString(date)}T12:00:00`;
}
